import React from 'react';
import ReportFrame from '../ReportFrame';

export default class ClientAssignmentRevenueExpenses extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Client Assignment Revenue and Expenses Summary'
          reportParams={reportParams}
          id='clientassignmentrevenueandexpensessummary'
          name='clientassignmentrevenueandexpensessummary'
          title='Client Assignment Revenue & Expenses Summary'
        />
      </div>
    );
  }
}
